import { type WorkspaceAgentMutationToolName, type WorkspaceAgentMutationToolParams } from '@air/analytics';

import { readApplyTagsToolCallAssetCount } from '~/components/v2/components/workspace/workspace-agent-panel/schemas/readApplyTagsToolCallAssetCount';
import { type ToolCall } from '~/components/v2/components/workspace/workspace-agent-panel/schemas/toolCallMetadata';

export type EnrichWorkspaceAgentMutationToolParamsInput = {
  toolCall: ToolCall | undefined;
  toolName: WorkspaceAgentMutationToolName;
  toolParams: WorkspaceAgentMutationToolParams;
};

export const enrichWorkspaceAgentMutationToolParams = ({
  toolCall,
  toolName,
  toolParams,
}: EnrichWorkspaceAgentMutationToolParamsInput): WorkspaceAgentMutationToolParams => {
  if (toolName !== 'apply_tags') {
    return toolParams;
  }

  const assetCount = readApplyTagsToolCallAssetCount(toolCall?.arguments);

  if (assetCount === undefined) {
    return toolParams;
  }

  return {
    ...toolParams,
    asset_count: assetCount,
  };
};
